export default [
    {
        path: 'relatorio-dispensacao-paciente',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-dispensacao-paciente' */
            '@/views/farmacia/relatorio-dispensacao-paciente/Index'
        ),
        redirect: 'relatorio-dispensacao-paciente/index',
        children: [
            {
                name: 'farmacia-relatorio-dispensacao-paciente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-dispensacao-paciente' */
                    '@/views/farmacia/relatorio-dispensacao-paciente/List'
                ),
            },
        ]
    }
]